define('modules/lists/modals/views/delete.list.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'select2',
    'modules/base/models/identity.profile.model',
    'modules/base/modals/views/modal.view',
    "text!modules/lists/modals/templates/delete.list.template.html"
], function(
    Prospector,
    $, _,Backbone, Select2,
    IdentityModel,
    ModalView,
    Template
){
    var DeleteListView = ModalView.extend({
        template: _.template(Template),
        mEvents:function() {
            var base = {
            };
            var click = {
                'click .confYes' : 'deleteList'
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options) {
            this.debugName = 'delete list view';
            var that = this;
            this.model = options.model;
        },
        onRender:function(){
            this.$('.deleteText').html('Are you sure you want to delete the "'+ this.model.get('name') +'" list?');
            ModalView.prototype.onRender.call(this);
        },
        deleteList:function(){
            this.model.once('sync', this.procDeleteList, this);
            this.model.creating = true;
            this.model.set({
                id: parseInt(this.model.get('source').refId)
            });
            this.errOut('Deleting the "'+ this.model.get('name') +'" list....');
            this.model.destroy();
        },
        procDeleteList:function(){
            var that = this;
            window.userProfile.fetch({
                success:function(){
                    that.closeModal();
                    Prospector.trigger('dashboard');
                }
            });
        }
    });
    return DeleteListView;
});
